<div class="sub-answer__label">
    <label class="sub-answer__labelText" [innerHtml]="subquestion.libelle"> </label>
</div>
<div class="sub-answer__input">
    <input [id]="subquestion.id + '-' + controlId" class="textfield textfield--full" [formControl]="myControl" [max]="maxDate" [min]="minDate" [matDatepicker]="picker" placeholder="JJ/MM/AAAA" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker color="primary" #picker></mat-datepicker>
</div>
